/**
 * "Varav moms" — the VAT inside the buyer's total, as one line under it
 * (P25009-475 BR-3). The seller's breakdown prints the same line under
 * "Totalt betalt" (P25009-494 BR-8).
 *
 * The buyer's rows are all incl. VAT, so the VAT is not a row of its own that
 * adds to the total; it is part of the total, and this line says how much.
 * The amount covers the whole order (orderVatCore.buyerPrices). No line at all
 * when the order carries no VAT — a private seller's used goods — because a
 * zero would suggest tax was charged.
 */
import React from 'react';
import { number, string } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

const LineItemVatIncludedMaybe = props => {
  const { vatSubunits, currency, intl, labelId } = props;
  if (!(vatSubunits > 0) || !currency) {
    return null;
  }

  return (
    <div className={css.vatIncluded}>
      <span className={css.itemLabel}>
        <FormattedMessage id={labelId} />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, new Money(vatSubunits, currency))}</span>
    </div>
  );
};

LineItemVatIncludedMaybe.defaultProps = {
  vatSubunits: 0,
  currency: null,
  labelId: 'OrderBreakdown.vatOfTotal',
};

LineItemVatIncludedMaybe.propTypes = {
  vatSubunits: number,
  currency: string,
  // The seller's breakdown says the VAT is theirs to report (P25009-494).
  labelId: string,
  intl: intlShape.isRequired,
};

export default LineItemVatIncludedMaybe;
